/* eslint-disable react/jsx-props-no-spreading */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  type DialogProps,
} from '@efexteam/components';
import { DateTime } from 'luxon';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Country } from '../../configs/language';
import accountstatusSvc from '../../services/accountStatus/accountstatusSvc';
import { selectProfileState } from '../profile/store/selectors';
import { selectSelectedLanguage } from '../store/language/selectors';
import FirstStepInvoiceDate from './invoicesdate/step1';
import SecondStepInvoiceDate from './invoicesdate/step2';

interface InvoiceDateModalProps extends DialogProps {
  onClose: () => void;
}

enum AccountStatusPage {
  chooseDates = 1,
  mailSendingView = 2,
}

const InvoiceDateModal = ({
  open,
  onClose,
  ...props
}: InvoiceDateModalProps) => {
  const { t } = useTranslation();
  const selectLanguage = useSelector(selectSelectedLanguage);
  const userProfile = useSelector(selectProfileState);
  const [valueStartDate, setValueStartDate] = useState<DateTime | null>(null);
  const [valueEndDate, setValueEndDate] = useState<DateTime | null>(null);
  const [page, setPage] = useState(1);

  const handleDownload = async () => {
    await accountstatusSvc.reportInvoiceDate({
      firstDate: valueStartDate?.toISODate(),
      secondDate: valueEndDate?.toISODate(),
      country: (userProfile.data?.company?.country as Country)
        ? (userProfile.data?.company?.country as Country)
        : selectLanguage.country,
      language: selectLanguage.language,
    });
  };

  const goNextPage = async () => {
    setPage((statePage) => statePage + 1);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" {...props}>
      <DialogTitle showCloseButton onClick={onClose} />
      <DialogContent>
        {page === AccountStatusPage.chooseDates && (
          <FirstStepInvoiceDate
            setValueStartDate={setValueStartDate}
            setValueEndDate={setValueEndDate}
          />
        )}
        {page === AccountStatusPage.mailSendingView && (
          <SecondStepInvoiceDate />
        )}
      </DialogContent>
      <DialogActions>
        {page === AccountStatusPage.chooseDates && (
          <Button
            appearance="primary"
            className="mx-auto mt-4 btn-download"
            disabled={!valueStartDate || !valueEndDate}
            onClick={() => {
              goNextPage();
              handleDownload();
            }}
          >
            {t('export')}
          </Button>
        )}
        {page === AccountStatusPage.mailSendingView && (
          <Button
            appearance="primary"
            className="mx-auto mt-4"
            disabled={!valueStartDate || !valueEndDate}
            onClick={onClose}
          >
            {t('close')}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default InvoiceDateModal;
